module.exports = __webpack_public_path__ + "images/offer-placeholder.03d61ee4.png";